// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1hJ_p","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__SIull"};